(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService($uibModal) {
        var service = {
            open: open,
            reset: reset
        };

        var modalInstance = null;
        var modalInstance2 = null;
        var resetModal = function () {
            modalInstance = null;
            modalInstance2 = null;
        };

        return service;

        /**
         * Opens the sign-in modal and returns its result promise: it resolves once the user is
         * signed in and rejects if they close it. Callers that interrupted something to ask for a
         * sign-in use that to pick the interrupted action back up, instead of leaving the user
         * signed in but staring at the page they started from.
         *
         * The promise is returned on both paths, the already-open one included — a second caller
         * that got `undefined` there had no way to know when the sign-in finished, and simply
         * gave up.
         */
        function open() {
            if (modalInstance2 !== null) modalInstance2.close();
            if (modalInstance !== null) return modalInstance.result;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            // modalInstance2 is null on the normal path (no reset dialog open), so dereferencing
            // it unconditionally threw a TypeError after the login modal had already been shown.
            var opened = modalInstance;
            opened.result.then(resetModal, resetModal);
            if (modalInstance2 !== null) modalInstance2.result.then(resetModal, resetModal);
            // Read from the local: resetModal has already nulled the field by the time anything
            // awaits this, and returning modalInstance.result would then throw.
            return opened.result;
        }

        function reset() {
            if (modalInstance !== null) modalInstance.close();
            if (modalInstance2 !== null) return;
            modalInstance2 = $uibModal.open({
                animation: true,
                templateUrl: 'app/account/reset/request/reset.request.html',
                controller: 'RequestResetController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reset');
                        $translatePartialLoader.addPart('login');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(resetModal, resetModal);
            modalInstance2.result.then(resetModal, resetModal);
        }
    }
})();
